import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    stake: 'Stake',
    approve: 'Approve',
    inputTokenLabel: 'Amount {token}',
    income:
      // eslint-disable-next-line no-template-curly-in-string
      'Your yearly income will be <span>~{value} {token}</span> {usdValue} based on <span>{apy}% APY</span>',
    receiveLabel: 'You receive',
    exchangeRateLabel: 'Exchange rate',
    rateValues: '{input} = {output}',
  },
};
